
import Vue from 'vue'

const getDefaultState = () => {
    return {
        promotion: {
            id: 0,
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`promotion/list`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listPromotion = result.data.result;

                return listPromotion;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list promotions: [${ex}]`
            };
        }
    },

    async ListValidPromotion() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`promotion/list-valid-promotion`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listPromotion = result.data.result;

                return listPromotion;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list promotions: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`promotion/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get promotion`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get promotion: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, promotionRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post(`promotion/create-update`, promotionRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                let msg = "Register updated with success!";

                if (promotionRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    idPromotion: result.data.result,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    idPromotion: 0,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async UpdateStatus(_, { id, statusId }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`promotion/update-status/${id}/${statusId}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Status updated with success!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error updating the status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error updating the status: [${ex}]`
            };
        }
    },

    async ListPhases() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`promotion/list-phases`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listPhases = result.data.result;

                return listPhases;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list phases promotions: [${ex}]`
            };
        }
    },

}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.promotion, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.promotion;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
